import React from 'react';
import { MetricCardProps } from '../types';
import { TrendingUp, TrendingDown } from 'lucide-react';

export default function MetricCard({ 
  title, 
  value, 
  change, 
  trend, 
  platform,
  description,
  className,
  invertColor,
}: MetricCardProps & { invertColor?: boolean }) {
  // For metrics where "lower is better" (e.g. MER), the arrow still points in the direction the
  // value actually moved, but green/red gets flipped — a decrease is good (green), an increase
  // is bad (red), the opposite of every other tile's default up=green/down=red convention.
  const colorTrend = invertColor ? (trend === 'up' ? 'down' : trend === 'down' ? 'up' : trend) : trend;
  return (
    <div
      className={`bento-card p-6 select-none group relative overflow-hidden ${className || ''}`}
    >
      {/* Background soft glow accent */}
      <div className="absolute top-0 right-0 h-16 w-16 bg-white/2 rounded-full blur-xl group-hover:bg-blue-500/5 transition-all duration-300" />
      
      <div className="space-y-3.5">
        <div className="flex items-center justify-between">
          <span className="text-[10px] font-mono tracking-wider uppercase text-stone-500">
            {platform || 'Unified Metric'}
          </span>
          {change && (
            <span className={`px-2 py-0.5 rounded-full text-[10px] font-mono font-medium flex items-center gap-1 ${
              colorTrend === 'up' 
                ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/15' 
                : colorTrend === 'down' 
                ? 'bg-rose-500/10 text-rose-400 border border-rose-500/15' 
                : 'bg-stone-800 text-stone-300'
            }`}>
              {trend === 'up' ? <TrendingUp className="h-3 w-3" /> : trend === 'down' ? <TrendingDown className="h-3 w-3" /> : null}
              {change}
            </span>
          )}
        </div>

        <div className="space-y-1.5">
          <h4 className="text-xs font-sans text-stone-400 group-hover:text-stone-300 transition-colors">
            {title}
          </h4>
          <div className="text-2xl font-display font-bold text-stone-100 font-mono tracking-tight flex items-baseline gap-1.5">
            {value}
          </div>
          {description && (
            <p className="text-[11px] font-sans text-stone-500 leading-snug pt-1 border-t border-stone-800/60 mt-2">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

